module.exports = __webpack_public_path__ + "img/icon_candy_red.cbcca375.svg";